import axios from 'axios';

const API_URL = 'https://sonapi.nantech.az/api/User';  

export const UserService = {
    getAllUsers: async () => {
        try {
            const response = await axios.get(`${API_URL}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${localStorage.getItem("accessToken")}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error fetching users:", error);
            throw error;
        }
    },

    getUserById: async (id) => {
        try {
            const response = await axios.get(`${API_URL}/${id}`,{
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem("accessToken")}`
                }
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching user:", error);
            throw error;
        }
    },

    updateUser: async (id, updatedData) => {
        try {
            await axios.put(`${API_URL}/${id}`, updatedData, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem("accessToken")}`
                }
            });
        } catch (error) {
            console.error("Error updating user:", error.response?.data || error.message);
            throw error;
        }
    },

    deleteUser: async (id) => {
        try {
            const response = await axios.delete(`${API_URL}/${id}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${localStorage.getItem("accessToken")}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("İstifadəçi silinərkən səhv baş verdi:", error.response?.data || error.message);
            throw error;
        }
    },

    getUserOrders: async (userId) => {
        try {
            const response = await axios.get(`${API_URL}/${userId}/orders`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem("accessToken")}`
                }
            });
            return response.data; 
        } catch (error) {
            console.error("Error fetching user orders:", error);
            throw error;
        }
    }
};
